import NoDataComponent from '@Components/General/Feedback/no-data-component';
import { AddCircleOutlineRounded, Groups2Rounded } from '@mui/icons-material';
import { Button, Icon } from '@mui/material';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

const NoEmailsSent = () => {
    const { t } = useTranslation();

    return (
        <NoDataComponent
            primary={t('prompts:noData.emailsSent.noEmailsSent.primary')}
            secondary={t('prompts:noData.emailsSent.noEmailsSent.secondary')}
            Icon={'local_post_office'}
            action={
                <Button
                    startIcon={<AddCircleOutlineRounded />}
                    color="primary"
                    LinkComponent={Link}
                    to="drafts/new"
                >
                    {t('Create Email')}
                </Button>
            }
        />
    );
};

export default NoEmailsSent;
